<div class="automatic-map">
  <div class="automatic-map__title title title--s">Карта скорректированного маршрута</div>
  <div class="automatic-map__sequence-hint">
    № на метке — плановый порядок заявки в маршруте сотрудника. У каждого сотрудника своя нумерация.
  </div>

  <div class="automatic-map__legend" *ngIf="routeLegend.length">
    <label
      class="automatic-map__legend-item"
      *ngFor="let route of routeLegend; trackBy: trackByRouteLegend"
      title="Показать маршрут сотрудника"
    >
      <input
        class="automatic-map__legend-checkbox"
        type="checkbox"
        [checked]="isRouteChecked(route)"
        (change)="toggleRouteSelection(route)"
      />
      <span class="automatic-map__legend-color" [style.backgroundColor]="route.color"></span>
      <span class="automatic-map__legend-name">{{ route.name }}</span>
      <app-icon
        [glyph]="route.transportIcon"
        [size]="'16'"
        [class]="'automatic-map__legend-transport'"
        [attr.title]="route.transportTitle"
      ></app-icon>
      <span class="automatic-map__legend-count">{{ route.totalOrders }} заявок</span>
    </label>
  </div>

  <div class="automatic-map__body">
    <app-automatic-distribution-osm-map
      [routeOrders]="visibleRouteOrders"
      [unassignedOrders]="visibleUnassignedOrders"
      [routeLines]="visibleRouteLines"
      [startMarkers]="visibleStartMarkers"
      [coordinates]="visibleCoordinates"
      [tickets]="tickets"
      [resolveCoordinates]="getCoordinates"
      [renderKey]="mapRenderKey"
    ></app-automatic-distribution-osm-map>

    <div class="automatic-map__empty" *ngIf="!hasVisibleCoordinates">Нет координат для отображения результата на карте.</div>
  </div>
</div>
